// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../../lunch-team-client-checkout-msg/node_modules/css-loader/index.js!../../../../../lunch-team-client-checkout-msg/node_modules/sass-loader/dist/cjs.js!./Login.scss");
if(typeof content === 'string') content = [[module.id, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = require("!../../../../../lunch-team-client-checkout-msg/node_modules/style-loader/lib/addStyles.js")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(module.hot) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../lunch-team-client-checkout-msg/node_modules/css-loader/index.js!../../../../../lunch-team-client-checkout-msg/node_modules/sass-loader/dist/cjs.js!./Login.scss", function() {
			var newContent = require("!!../../../../../lunch-team-client-checkout-msg/node_modules/css-loader/index.js!../../../../../lunch-team-client-checkout-msg/node_modules/sass-loader/dist/cjs.js!./Login.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}


//////////////////
// WEBPACK FOOTER
// ./src/containers/Landing/Header/Login.scss
// module id = 842
// module chunks = 7